import { UserLayout } from "@/components/layouts/user-layout"
import { usePage } from "@inertiajs/react"
import { MainContainer } from "@/components/ui/container"
import { ProfileForm } from "@/components/features/profiles/profile-form"
import { SecurityCard } from "@/components/features/profiles/security-card"

type SharedUser = {
  name: string
  email: string
  initials: string
  avatar: string | null
  hasPassword?: boolean
}

type Props = {
  /** OmniAuth provider keys backing this account, e.g. `google_oauth2`. */
  connectedProviders: string[]
}

/**
 * The account screen: who this diner is, and what protects the account.
 *
 * Security sits beside the identity form rather than inside it — the card
 * navigates to `/profile/password`, it never grows password fields of its own.
 * SecurityCard carries the reasoning.
 */
export default function UserProfilesEdit({ connectedProviders }: Props) {
  const { user } = usePage<{ user: SharedUser | null }>().props

  if (!user) return null

  return (
    <UserLayout>
      <MainContainer size="xs">
        <div className="space-y-6" data-testid="profile-edit-view">
          <ProfileForm defaultValues={{ name: user.name, email: user.email }} />
          <SecurityCard
            hasPassword={Boolean(user.hasPassword)}
            connectedProviders={connectedProviders}
          />
        </div>
      </MainContainer>
    </UserLayout>
  )
}
